/**
 * Class description
 *
 * Created: 2017-11-06
 * @author jonas
 */
export class WaveConfig {
    public spreadDuration:number;
    public returnDuration:number;
    public forceCalculation:(distance:number, longestDistance:number) => number;
    public positionMultiplier:number;
    public scaleFactor:number;

    constructor(spreadDuration:number = 0.1, returnDuration:number = 0.8, positionMultiplier:number = 1, scaleFactor:number, forceCalculation?:(distance:number, longestDistance:number) => number) {
        this.spreadDuration = spreadDuration;
        this.returnDuration = returnDuration;
        this.positionMultiplier = positionMultiplier;
        this.scaleFactor = scaleFactor;
        this.forceCalculation = forceCalculation ? forceCalculation : WaveConfig.defaultForceCalculation;
    }

    public static defaultForceCalculation(distance:number, longestDistance:number):number {
        return distance != 0 ? (1 + longestDistance) - distance : 0;
    }

    public static flatForce(distance:number, longestDistance:number):number {
        return distance != 0 ? (1 + longestDistance) * 0.1 : 0;
    }

    public static landingForce(distance:number, longestDistance:number):number {
        return Math.max(4 - distance, 0) * 0.1;
    }

    public static transformForce(distance:number, longestDistance:number):number {
        return Math.max(4 - distance, 1) * 0.3;
    }
}